import { render, staticRenderFns } from "./ac1.vue?vue&type=template&id=90c6c3da&scoped=true&"
import script from "./ac1.vue?vue&type=script&lang=js&"
export * from "./ac1.vue?vue&type=script&lang=js&"
import style0 from "./ac1.vue?vue&type=style&index=0&id=90c6c3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c6c3da",
  null
  
)

export default component.exports